import React, { useState } from "react";
import { Card, Form, Button, Collapse, Row, Col, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const ExplorePunjabMagazineSection = ({ data, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleFileUpload = async (field, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange(field, res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Explore Punjab Magazine Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Collapse in={isOpen}>
          <Card.Body>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Heading</Form.Label>
                  <Form.Control
                    type="text"
                    value={data.heading}
                    onChange={(e) => handleChange("heading", e.target.value)}
                    placeholder="Enter section heading"
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={data.description}
                    onChange={(e) => handleChange("description", e.target.value)}
                    placeholder="Enter section description"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Background Image</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      e.target.files?.[0] &&
                      handleFileUpload("backgroundImage", e.target.files[0])
                    }
                  />
                  {isUploading && (
                    <div className="text-muted small mt-1">Uploading...</div>
                  )}
                  {data.backgroundImage && (
                    <div className="mt-2">
                      <Image
                        src={data.backgroundImage}
                        alt="Background Preview"
                        thumbnail
                        style={{ maxWidth: "200px" }}
                      />
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Magazine Image</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      e.target.files?.[0] &&
                      handleFileUpload("magazineImage", e.target.files[0])
                    }
                  />
                  {isUploading && (
                    <div className="text-muted small mt-1">Uploading...</div>
                  )}
                  {data.magazineImage && (
                    <div className="mt-2">
                      <Image
                        src={data.magazineImage}
                        alt="Magazine Preview"
                        thumbnail
                        style={{ maxWidth: "200px" }}
                      />
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Download Link</Form.Label>
                  <Form.Control
                    type="url"
                    value={data.downloadLink}
                    onChange={(e) => handleChange("downloadLink", e.target.value)}
                    placeholder="Enter magazine download link"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Collapse>
      )}
    </Card>
  );
};

export default ExplorePunjabMagazineSection;
